export enum ModalSize {
  DEFAULT = 'DEFAULT',
  LARGE = 'LARGE',
  SMALL = 'SMALL',
  X_LARGE = 'X_LARGE',
  FULL_SCREEN = 'FULL_SCREEN',
  FULL_WIDTH = 'FULL_WIDTH',
  CUSTOM_WIDTH = 'CUSTOM_WIDTH'
}
